import { logErrorDebug } from './debug/debugLogging'

const baseUrl = '/webapi/v1/cashsales'

export interface CashSalesCartItem {
  itemNumber: string
  quantity?: number
}

export interface CashSalesCartItemResult extends CashSalesCartItem {
  status: boolean
  message: string | null
}

export interface CashSalesAddToCartResponse {
  status: boolean
  message: null
  results: CashSalesCartItemResult[]
}

interface CashSalesStatusResponse {
  isCashsalesUser: boolean
  isSeEmployee: boolean
  isShowroomConsultant: false
  roles: readonly string[]
  status: boolean
  message: string | null
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function addCashSalesCartItems(items: CashSalesCartItem[]): Promise<CashSalesAddToCartResponse> {
  return fetch(`${baseUrl}/addcartitems`, {
    method: 'POST',
    body: JSON.stringify({ items }),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(res => {
      if (!res.ok) {
        throw Error(res.statusText)
      }

      return res.json()
    })
    .then(results => results as CashSalesAddToCartResponse)
    .catch(e => {
      logErrorDebug('error adding to cash sales cart', e)
      throw e
    })
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function getCashSalesStatus(): Promise<CashSalesStatusResponse> {
  return fetch(`${baseUrl}/getstatus`, {
    method: 'GET',
  })
    .then(res => {
      if (!res.ok) {
        throw Error(res.statusText)
      }

      return res.json()
    })
    .then(results => results as CashSalesStatusResponse)
    .catch(e => {
      logErrorDebug('error getting sales status', e)
      throw e
    })
}


interface CashSalesInterface {
  getStatus(): Promise<CashSalesStatusResponse>
  addCartItems(items: CashSalesCartItem[]): Promise<CashSalesAddToCartResponse>
}

function getRandomMockErrorMessage() {
  const messages = [
    'Sorry, this item is not available for sale',
    'Product not found',
    'Sorry, item is out of stock',
  ]

  return messages[Math.floor(Math.random() * 3) % 3]
}

export function delayPromise<T>(delay: number, getPromise: () => Promise<T>): Promise<T> {
  return new Promise<void>(resolve => {
    setTimeout(() => resolve(), delay)
  })
    .then(() => getPromise())
}

const MockCashSalesImplementation: CashSalesInterface = {
  getStatus() {
    return delayPromise(500, () => Promise.resolve({
      isCashsalesUser: true,
      isSeEmployee: true,
      isShowroomConsultant: false,
      roles: [],
      status: true,
      message: null,
    }))
  },

  addCartItems(items) {
    return delayPromise(500, () => {
      return Promise.resolve<CashSalesAddToCartResponse>({
        status: true,
        message: null,
        results: items.map(item => {
          const isSuccessful = Math.round(Math.random() * 2) !== 0
          return {
            ...item,
            status: isSuccessful,
            message: isSuccessful ? null : getRandomMockErrorMessage(),
          }
        })
      })
    })
  }
}

const CashSalesImplementation: CashSalesInterface = {
  getStatus: getCashSalesStatus,
  addCartItems: addCashSalesCartItems,
}

export const CashSalesApi: CashSalesInterface = process.env.REACT_APP_MOCK_CASH_SALES_API === 'true' ? MockCashSalesImplementation : CashSalesImplementation
